/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualMaterialDto } from '../../models/backend-actual-material-dto';

export interface MonitoringActualsMaterialsList$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
}

export function monitoringActualsMaterialsList(
  http: HttpClient,
  rootUrl: string,
  params?: MonitoringActualsMaterialsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendActualMaterialDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsMaterialsList.PATH, 'get');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendActualMaterialDto>>;
    }),
  );
}

monitoringActualsMaterialsList.PATH = '/api/monitoring/actuals/materials/';
